const productSectionStack = (flexDirection, stackPropsStyle) => ({
  flexDirection: { xs: 'column-reverse', md: flexDirection },
  gap: '2.5rem',
  width: '85%',
  maxWidth: '80rem',
  ...stackPropsStyle,
});

const imageContainer = {
  width: { xs: '100%', sm: '70%', md: '50%' },
};

const imageStyles = {
  objectFit: 'contain',
  width: '100%',
  height: '100%',
  objectPosition: 'center',
  display: 'block',
  alignSelf: 'center',
};

const contentStack = {
  justifyContent: 'flex-start',
  gap: '1.5rem',
  flex: '1 0 0',
};

const iconContainer = {
  width: { xs: '3.5rem', md: '4rem' },
  height: { xs: '3.5rem', md: '4rem' },
  padding: '0.93rem',
  borderRadius: '62.4rem',
  background: 'white',
  boxShadow: '0 8px 50px 0 rgba(107, 107, 107, 0.25)',
};

const iconStyles = {
  objectFit: 'cover',
  width: '100%',
  height: '100%',
};

const titleTypography = (theme) => ({
  color: theme.palette.neutral.A700,
  fontWeight: 600,
  fontSize: { xs: '1.75rem', sm: '2.5rem' },
});

const textTypography = (theme) => ({
  color: theme.palette.neutral.A500,
  fontWeight: 500,
  textAlign: { xs: 'justify', lg: 'left' },
  fontSize: { xs: '1rem', phone: '1.125rem' },
});

export {
  productSectionStack,
  imageContainer,
  imageStyles,
  contentStack,
  iconContainer,
  iconStyles,
  titleTypography,
  textTypography,
};
